import { createSelector } from "reselect";

const selectSubject = (state) => state.subject;

export const createModal = createSelector(
  [selectSubject],
  (subject) => subject.createModal
);

export const subjectLoading = createSelector(
  [selectSubject],
  (subject) => subject.isLoading
);

export const subjectList = createSelector(
  [selectSubject],
  (subject) => subject.subjects
);

export const selectIsCreatingSubject = createSelector(
  [selectSubject],
  (subject) => subject.isCreatingSubject
);

export const selectIsEditingSubject = createSelector(
  [selectSubject],
  (subject) => subject.isEditingSubject
);
